import React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./StatsViews.styles";

export interface INewUsersViewProps extends WithStyles<typeof styles> {
}

const NewUSersViewPure: React.FunctionComponent<INewUsersViewProps> = ({ classes }: INewUsersViewProps) => {

    return (
        <div>
            Coming soon...
        </div>
    );
};

export const NewUsersView = withStyles(styles)(NewUSersViewPure);
